module.exports = __webpack_public_path__ + "static/product-pa70-coyote-tan-24c7df31e64b787806efcee3b221b7e4.png";